import React from "react";
import styles from "./errorsInfo/ErrorsInfo.module.scss";
import ErrorBox from "../ErrorInfoBox/ErrorBox";

const ErrorsInfo = ({ errorTitle = 'DC Connection Lost', errorDescription, errorCode = "526" }) => {

    return (
        <div className={`d-flex align-items-center ${styles.ErrorsInfo}`}>
            <div className={`d-flex ${styles.icon}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.00012 11.9993C2.00012 6.48033 6.48012 1.99933 12.0001 1.99933C17.5301 1.99933 22.0001 6.48033 22.0001 11.9993C22.0001 17.5203 17.5301 21.9993 12.0001 21.9993C6.48012 21.9993 2.00012 17.5203 2.00012 11.9993ZM11.1201 8.20933C11.1201 7.73033 11.5201 7.32933 12.0001 7.32933C12.4801 7.32933 12.8701 7.73033 12.8701 8.20933V12.6293C12.8701 13.1103 12.4801 13.4993 12.0001 13.4993C11.5201 13.4993 11.1201 13.1103 11.1201 12.6293V8.20933ZM12.0101 16.6803C11.5201 16.6803 11.1301 16.2803 11.1301 15.8003C11.1301 15.3203 11.5201 14.9303 12.0001 14.9303C12.4901 14.9303 12.8801 15.3203 12.8801 15.8003C12.8801 16.2803 12.4901 16.6803 12.0101 16.6803Z" fill="#FF0053"/>
                </svg>
            </div>
            <div className={styles.hint}>
                <ErrorBox title={errorTitle} errorCode={'526'} width={'216px'} errorCode={errorCode}>
                    { errorDescription }
                </ErrorBox>
            </div>
            <div className={styles.errorTitle}>
                { errorTitle }
            </div>

        </div>
    )
}

export default ErrorsInfo;